module.exports = __webpack_public_path__ + "static/media/unmuteIcon.a0794033.svg";